import { storableError } from '../util/errors';
import { fetchCurrentUser } from './user.duck';

// ================ Action types ================ //

export const VERIFICATION_REQUEST = 'app/emailVerification/VERIFICATION_REQUEST';
export const VERIFICATION_SUCCESS = 'app/emailVerification/VERIFICATION_SUCCESS';
export const VERIFICATION_ERROR = 'app/emailVerification/VERIFICATION_ERROR';
export const SET_EMAIL_VERIFIED_MANUALLY = 'app/emailVerification/SET_EMAIL_VERIFIED_MANUALLY';

// ================ Reducer ================ //

const initialState = {
  isVerified: false,

  // verification
  verificationError: null,
  verificationInProgress: false,
  emailVerifiedManually: false
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case VERIFICATION_REQUEST:
      return {
        ...state,
        verificationInProgress: true,
        verificationError: null,
      };
    case VERIFICATION_SUCCESS:
      return { ...state, verificationInProgress: false, isVerified: true };
    case VERIFICATION_ERROR:
      return { ...state, verificationInProgress: false, verificationError: payload };
    case SET_EMAIL_VERIFIED_MANUALLY:
      return { ...state, emailVerifiedManually: payload };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const verificationInProgress = state => {
  return state.emailVerification.verificationInProgress;
};

// ================ Action creators ================ //

export const verificationRequest = () => ({ type: VERIFICATION_REQUEST });
export const verificationSuccess = () => ({ type: VERIFICATION_SUCCESS });
export const verificationError = error => ({
  type: VERIFICATION_ERROR,
  payload: error,
  error: true,
});
export const setEmailVerifiedManually = isVerified => ({
  type: SET_EMAIL_VERIFIED_MANUALLY,
  payload: isVerified,
});

// ================ Thunks ================ //

/* export const verify = verificationToken => (dispatch, getState, sdk) => {
  if (verificationInProgress(getState())) {
    return Promise.reject(new Error('Email verification already in progress'));
  }
  dispatch(verificationRequest());

  // Note that the thunk does not reject when the verification fails, it
  // just dispatches the login error action.
  console.log('Current user:', sdk.currentUser);
  return sdk.currentUser
    .verifyEmail({ verificationToken })
    .then(() => dispatch(verificationSuccess()))
    .then(() => dispatch(fetchCurrentUser()))
    .catch(e => {
      console.error('Email verification error:', {
        message: e.message,
        status: e.status,
        apiErrors: e.apiErrors,
        response: e.response,
      });
      dispatch(verificationError(storableError(e)));
    });
}; */

export const verify = verificationToken => (dispatch, getState, sdk) => {
  console.log('Verification token:', verificationToken);
  if (verificationInProgress(getState())) {
    console.log('Verification already in progress, aborting.');
    return Promise.reject(new Error('Email verification already in progress'));
  }
  dispatch(verificationRequest());
  return sdk.currentUser
    .show()
    .then(response => {
      console.log('Current user data:', response.data);
      /* if (response.data?.attributes?.emailVerified && !response.data?.attributes?.pendingEmail) {
        console.log('Email already verified, skipping API call');
        dispatch(verificationSuccess());
        dispatch(setEmailVerifiedManually(true));
        return dispatch(fetchCurrentUser());
      } */
      return sdk.currentUser.verifyEmail({ verificationToken });
    })
    .then(() => {
      console.log('Email verification successful');
      dispatch(verificationSuccess());
      
      dispatch(setEmailVerifiedManually(true)); // Set new state
      return dispatch(fetchCurrentUser());
    })
    .catch(e => {
      console.error('Email verification error:', {
        message: e.message,
        status: e.status,
        apiErrors: e.apiErrors,
        response: e.response,
      });
      dispatch(verificationError(storableError(e)));
    });
};
